<template>
  <div
    class="skeleton-loading circle-skeleton"
    :style="{ width: `${size}px`, height: `${size}px` }"
  ></div>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
  },
};
</script>

<style lang="postcss" scoped>
.circle-skeleton {
  box-sizing: border-box;
  border-radius: 50%;
}
</style>
